import React from "react";
import { useSelector } from "react-redux";
import Button from "components/button";

const ActionMenu = ({ user, onEdit, onPassword, onDelete }) => {
  const { user: userParms = {} } = useSelector(
    (state) => state.auth.permissions || {}
  );

  return (
    <div className="flex gap-1 ">
      {/* Edit */}
      {userParms?.edit && (
        <Button
          onClick={() => {
            onEdit(user);
          }}
        >
          Edit
        </Button>
      )}

      {/* Reset Password */}
      {userParms?.updatePassword && (
        <Button
          onClick={() => {
            onPassword(user);
          }}
        >
          Reset Password
        </Button>
      )}

      {userParms?.delete && (
        <Button
          variant="red"
          onClick={() => {
            onDelete(user);
          }}
        >
          <span>Delete</span>
        </Button>
      )}
    </div>
  );
};

export default ActionMenu;
